import { formatDate_MMM_YYYY, fromDateUnknown, getYearsAndMonths } from "../../modules/utilities"
import { COLOR, COLUMN, FORMATTING, TENSE } from "../../modules/constants"
import { getCellWithTooltip } from "../../modules/table.funcs"

const { number } = FORMATTING

export const commonLseTableData = props => {
  // console.log('commonLseTableData props:', props)
  const { apptInfo, column } = props
  const tooltip = ""
  switch (column) {
    case COLUMN.TENURE:
    default:
      const tenseColor = apptInfo.tense >= 0 ? TENSE[apptInfo.tense].COLOR : COLOR.BLACK
      const tenureToSort = apptInfo.tenureYears ? apptInfo.tenureYears : 0
      const tenureToPresent = getYearsAndMonths(apptInfo.from, apptInfo.until)

      return getCellWithTooltip({
        color: tenseColor,
        prefix: fromDateUnknown(new Date(apptInfo.from)) ? "at least" : null,
        sortValue: tenureToSort,
        tooltip,
        type: number,
        value: tenureToPresent,
      })
  }
}

// The 'year' parameter is the year of the review, and the 'month' parameter is used to create a Date object for accurate sorting.
// We use the month from the annual report's last date, defaulting to January if it's not available.
// @ts-ignore
export const buildDateValues = (month, year) => {
  if (!year) {
    return {
      display: "",
      sort: "",
      status: 0
    }
  }

  const d = new Date(year, month - 11)
  const sort = d.getFullYear() * 100 + (d.getMonth() + 1)
  const now = new Date()
  const in12Months = new Date()

  in12Months.setMonth(now.getMonth() + 12)

  let status = 0

  if (d < now)
    status = 2 // earlier / overdue
  else if (d <= in12Months)
    status = 1 // within 12 months
  else
    status = 0 // more than 12 months away

  return {
    display: formatDate_MMM_YYYY(d),
    sort,
    status
  }
}

